import Vue from 'vue';
import core, { CoreOptions } from '@glittr/frontend-core';
import toccoWidgets from '@glittr/frontend-core/src-modules/tocco/widgets';
import router from './router';
import servicesV1 from './services/v1';
import servicesV2 from './services/v2';
import ilLanguageSelection from './components/il-language-selection.vue';

Vue.config.productionTip = false;
// Core entry point
const coreOptions = {
  // appId: 'custom-mount-id'
  router,
  Vue,
} as CoreOptions;
// Core entry point
Vue.use(core, coreOptions);
Vue.nextTick(() => {
  toccoWidgets.loadModule(coreOptions, Vue);
});

// APP____________________________________________________________

// STYLES
require('./assets/styles/main.scss');

// PLUGINS
Vue.use(servicesV1);
Vue.use(servicesV2);

// COMPONENTS
Vue.component('IlLanguageSelection', ilLanguageSelection);

// GUARDS
// Vue.$guards.push(yourGuard);

// LAYOUTS
const reqLayouts = require.context('./views/layouts', true);
reqLayouts.keys().forEach((componentPath) => {
  let componentName = componentPath.substring(componentPath.lastIndexOf('/') + 1, componentPath.length - 1);
  componentName = componentName.replace('.vue', '');
  const component = reqLayouts(componentPath).default;
  Vue.component(componentName, component);
});

// _______________________________________________________________

declare module '@core/plugins/config/config' {
  interface ConfigType {
    // add custom config props here
    'shop-agburl': string;
    'shop-memberinfourl': string;
    'shop-articlenumber': string;
    'shop-articleid': string;
    'shop-categoryid': string;
    'shop-search': string;
  }
}
